module.exports = __webpack_public_path__ + "resources/img/img_i_onenet.f5f643390fc6bc45ed74f2f66178cb76.png";